interface Props {
  color?: string
}

export const MultipleFiles = ({ color = 'currentColor' }: Props) => {
  return (
    <svg width="33" height="34" viewBox="0 0 33 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="file-multiple">
        <path
          id="Icon"
          d="M15.8404 9.08005V13.0401C15.8404 13.7691 16.4314 14.3601 17.1604 14.3601H21.1204M23.7604 3.80005H14.5201C13.062 3.80005 11.8801 4.98201 11.8801 6.44003V9.08005M23.7604 3.80005H24.4967C24.8685 3.80005 25.2223 3.95662 25.4784 4.22606C25.8633 4.63096 26.4729 5.2544 27.0604 5.78005C27.5208 6.19202 28.2442 6.93136 28.6774 7.38069C28.9116 7.62369 29.0404 7.94814 29.0404 8.28567L29.0403 9.08005M23.7604 3.80005V7.76005C23.7604 8.48907 24.3514 9.08005 25.0804 9.08005H29.0403M29.0403 9.08005L29.04 22.2801C29.04 23.7381 27.858 24.9201 26.4 24.92H21.12M19.1404 11.0601C18.5529 10.5344 17.9433 9.91097 17.5584 9.50606C17.3023 9.23662 16.9485 9.08005 16.5767 9.08005H6.60006C5.14204 9.08005 3.96007 10.262 3.96006 11.72L3.95996 27.56C3.95995 29.018 5.14192 30.2 6.59995 30.2L18.48 30.2C19.938 30.2001 21.12 29.0181 21.12 27.5601L21.1204 13.5657C21.1204 13.2281 20.9916 12.9037 20.7574 12.6607C20.3242 12.2114 19.6008 11.472 19.1404 11.0601Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}
